import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { loginRequest } from '../authConfig';
import { useGoogleAuth } from '../contexts/GoogleAuthContext';
import vistaLogo from '../assets/vista-logo.svg';

const LoginPage: React.FC = () => {
    const { instance } = useMsal();
    const { signInWithGoogle } = useGoogleAuth();
    const [googleError, setGoogleError] = useState<string | null>(null);

    const handleMicrosoftLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error(error);
        }
    };

    const handleGoogleSuccess = async (response: CredentialResponse) => {
        setGoogleError(null);
        if (response.credential) {
            try {
                await signInWithGoogle(response.credential);
            } catch (error) {
                console.error(error);
                setGoogleError('Google sign-in failed on API authentication. Please try again.');
            }
        } else {
            setGoogleError('Google sign-in failed. Please try again.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <img className="login-logo" src={vistaLogo} alt="GJS IT Solutions & DevOps logo" />
                <p className="login-eyebrow">GJS IT Solutions & DevOps</p>
                <p>Sign in to continue.</p>
                <div className="login-buttons">
                    <button className="login-button" onClick={handleMicrosoftLogin}>
                        Sign in with Microsoft
                    </button>
                    {/* Overlay pattern: our styled button is visible, the transparent Google
                        iframe sits on top and intercepts the click to get a valid id_token. */}
                    <div className="login-google-wrapper">
                        <button className="login-button" tabIndex={-1} aria-hidden="true">
                            Sign in with Google
                        </button>
                        <div className="login-google-overlay">
                            <GoogleLogin
                                onSuccess={handleGoogleSuccess}
                                onError={() => setGoogleError('Google sign-in failed. Please try again.')}
                                useOneTap={false}
                                width="400"
                            />
                        </div>
                    </div>
                </div>
                {googleError && <p className="login-error">{googleError}</p>}
            </div>
        </div>
    );
};

export default LoginPage;
